import { Chains } from 'constants/chains'

export const validChainId: Chains = !!process.env.VALID_CHAIN_ID
  ? Number(process.env.VALID_CHAIN_ID)
  : Chains.POLYGON
